import PropTypes from 'prop-types'

import './AddAction.styles'
import { Checkbox } from '../../../shared/NarusMaterial/Checkbox'

import { ActionDescription } from './ActionDescription'

export const AddActionDescription = ({
  dueDays,
  description,
  onAdd,
  easyComplete,
  isCompleted,
  onComplete
}) => (
  <div className='row middle-xs action'>
    <div className='col-xs-8'>
      <ActionDescription
        dueDays={dueDays}
        description={description}
      />
    </div>
    {easyComplete
      ? (
        <div className='checkbox-wrapper'>
          <Checkbox
            value={isCompleted}
            label='Complete'
            onChange={() => {
              onComplete()
            }}
          />
        </div>
      )
      : null}
    <div className='btn-wrapper'>
      <button
        className='add-btn icon icon-circle-add'
        onClick={onAdd}
      />
    </div>
  </div>
)

AddActionDescription.propTypes = {
  description: PropTypes.string.isRequired,
  easyComplete: PropTypes.bool,
  isCompleted: PropTypes.bool,
  onAdd: PropTypes.func,
  onComplete: PropTypes.func
}
